<template >
  <div id="animation16interface">
    <lottie
      :options="defaultOptions"
      :autoplay="true"
      :speed="0.05"
      :loop="false"
      :height="450"
      :width="450"
      v-on:animCreated="handleAnimation"
    />
  
  </div> 
</template>

<style scoped>
.animation16interface {
  width:100%;
  height:100%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 1;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
// import Lottie from "./lottie.vue";
import Lottie from "vue-lottie";
import * as animationData from "./../assets/mockups/textelement8.json";

export default {
  name: "Animation6",
  components: {
    lottie: Lottie
  },
  data: () => ({
    defaultOptions: { animationData: animationData.default },
  }),
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
  }
};
</script>